export const ALTUS_INITIATE_QUOTE_BASIC_INFO_FORM_ID = 'altus-initiate-quote-basic-info-form';
